import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { NitroHeading, NitroPanel, NitroPlaceholder, NitroText, NitroBadge, NitroButton } from 'nitro-components';

import styled from 'styled-components';
import { isEmpty } from 'lodash';
import moment from 'moment';

import { formatSchedule } from '../../../report-edit/schedule';
import { translateRecipients } from '../../../report-edit/recipients';

const ScheduleInfo = styled.div`
  color: ${props => props.theme.color.base2};
  font-size: ${props => props.theme.size['2']};
`;

const RecipientsSection = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.border};
  padding: 20px 0;
  display: flex;
  align-items: center;
`;

const RecipientsHeading = styled.div`
  text-align: left;
  font-size: ${props => props.theme.size['2']};
  color: ${props => props.theme.color.secondary};
  font-family: ${props => props.theme.font.bold};
  width: 100px;
`;

const RecipientsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  > * {
    margin-right: 8px;
  }
`;

const Repeat = styled.span`
  color: ${props => props.theme.color.secondary};
  font-size: ${props => props.theme.size['2']}px;
  font-family: ${props => props.theme.font.bold};
  text-transform: lowercase;
`;

class Schedule extends Component {
  goTo = () => {
    this.props.goToStep(this.props.step);
  }
  render() {
    const { schedule, recipients } = this.props;
    if (!schedule) {
      return <NitroButton label="+ ADD SCHEDULE" variant="secondary" size="extraSmall" action={this.goTo} />;
    }

    const { repeat, occurrence, repeatAt, startingFrom } = schedule;

    const { to, cc, bcc } = recipients;
    return (
      <div>
        <NitroHeading label="Frequency" size="3" variant="secondary" />
        <NitroPanel boxShadowLight>
          <ScheduleInfo>
            Repeats{' '}
            <Repeat variant="secondary" bold size="2">
              {repeat}
            </Repeat>{' '}
            {!isEmpty(occurrence) &&
              <span>
                on{' '}
                {occurrence.map(o =>
                  <NitroText key={o} variant="secondary" bold size="2">
                    {o}{' '}
                  </NitroText>
                )}
              </span>}{' '}
            at{' '}
            <NitroText variant="secondary" bold size="2">
              {repeatAt}
            </NitroText>{' '}
            starting from{' '}
            <NitroText variant="secondary" bold size="2">
              {moment(startingFrom).format('Do MMM YYYY').toString()}
            </NitroText>
          </ScheduleInfo>
        </NitroPanel>
        <NitroPlaceholder size={10} />
        <NitroHeading label="Recipients" size="3" variant="secondary" />
        <RecipientsSection>
          <RecipientsHeading>
            To <NitroBadge variant="secondary" size={10} label={to.length} />
          </RecipientsHeading>
          <RecipientsList>
            {to.map((recipient, index) =>
              <NitroPanel noMargin key={recipient} boxShadowLight padding="8px 20px">
                <NitroText size="2" variant="secondary">
                  {recipient}
                </NitroText>
              </NitroPanel>
            )}
          </RecipientsList>
        </RecipientsSection>
        <RecipientsSection>
          <RecipientsHeading>
            Cc <NitroBadge variant="secondary" size={10} label={cc.length} />
          </RecipientsHeading>
          <RecipientsList>
            {cc.map((recipient, index) =>
              <NitroPanel noMargin key={recipient} boxShadowLight padding="8px 20px">
                <NitroText size="2" variant="secondary">
                  {recipient}
                </NitroText>
              </NitroPanel>
            )}
          </RecipientsList>
        </RecipientsSection>
        <RecipientsSection>
          <RecipientsHeading>
            Bcc <NitroBadge variant="secondary" size={10} label={bcc.length} />
          </RecipientsHeading>
          <RecipientsList>
            {bcc.map((recipient, index) =>
              <NitroPanel noMargin key={recipient} boxShadowLight padding="8px 20px">
                <NitroText size="2" variant="secondary">
                  {recipient}
                </NitroText>
              </NitroPanel>
            )}
          </RecipientsList>
        </RecipientsSection>
      </div>
    );
  }
}

Schedule.propTypes = {
  schedule: PropTypes.object,
  recipients: PropTypes.object,
  goToStep: PropTypes.func,
};

// TODO: move to selector
const mapStateToProps = state => {
  const { schedule, recipients } = state.reports;

  return { schedule: formatSchedule(schedule, recipients), recipients };
};

export default connect(mapStateToProps)(Schedule);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/Sections/Schedule.js